import React, { useState } from "react";

export const Navigation = () => {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="nav-inner">
        <a href="#page-top" className="nav-logo page-scroll" onClick={close}>
          <img src="img/logo-mindware-bw.png" alt="Mindware" />
        </a>

        <div className="nav-links">
          <a href="#products" className="nav-link page-scroll">Products</a>
          <a href="#services" className="nav-link page-scroll">What We Do</a>
          <a href="#blog" className="nav-link page-scroll">Blog</a>
          <a href="#contact" className="nav-cta page-scroll">Get in Touch</a>
        </div>

        <button
          className="nav-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`nav-mobile${open ? " open" : ""}`}>
        <a href="#products" className="nav-link page-scroll" onClick={close}>Products</a>
        <a href="#services" className="nav-link page-scroll" onClick={close}>What We Do</a>
        <a href="#blog" className="nav-link page-scroll" onClick={close}>Blog</a>
        <a href="#contact" className="nav-cta page-scroll" onClick={close}>Get in Touch</a>
      </div>
    </nav>
  );
};
